// extracted by mini-css-extract-plugin
module.exports = {"sidePanelLinks":"ImportantLinks_sidePanelLinks__RAD41"};